<template>
  <div v-if="done < tasks.length" ref="root" class="v5-pop-wrap v5-gs">
    <button class="v5-gs__btn" type="button" :aria-expanded="String(open)" aria-controls="v5-gs" @click="toggle">
      <span class="v5-gs__row">{{ t('v5.shell.get_started') }} <b class="num">{{ t('v5.shell.n_of_m', { n: done, m: tasks.length }) }}</b></span>
      <span class="v5-meter" aria-hidden="true"><i :style="{ width: `${(done / tasks.length) * 100}%` }" /></span>
    </button>
    <div v-if="open" id="v5-gs" class="v5-pop v5-pop--up">
      <ul class="v5-gs__list">
        <li v-for="task in tasks" :key="task.key" :class="{ done: task.done }">
          <CheckIcon v-if="task.done" class="i" aria-hidden="true" />
          <i v-else aria-hidden="true" />
          <span v-if="task.done"><b>{{ t(`v5.shell.tasks.${task.key}`) }}</b><small>{{ t(`v5.shell.tasks.${task.key}_hint`) }}</small><span class="sr">{{ t('v5.shell.task_done') }}</span></span>
          <router-link v-else :to="settingsLink"><b>{{ t(`v5.shell.tasks.${task.key}`) }}</b><small>{{ t(`v5.shell.tasks.${task.key}_hint`) }}</small></router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { CheckIcon } from '@heroicons/vue/24/outline';
import usePopover from './usePopover';
import { v5OrClassic } from '../nav';

// The classic sidebar's setup checklist (DashboardLayout userCheckListProgress), hidden once done
const props = defineProps({ user: { type: Object, required: true } });
const { t } = useI18n();
const router = useRouter();
const { open, root, toggle } = usePopover();

const tasks = computed(() => [
  { key: 'auth_code', done: !!props.user.has_match_auth_token },
  { key: 'match_token', done: !props.user.match_token_outdated },
  { key: 'steam_bot', done: !!props.user.has_steam_bot_added },
  { key: 'faceit', done: !!props.user.faceit_nickname },
  { key: 'discord', done: !!props.user.has_discord_linked },
]);
const done = computed(() => tasks.value.filter((x) => x.done).length);
const settingsLink = computed(() => v5OrClassic(router, '/v5/settings', '/settings'));
</script>
